import { PayPlanChangeRequestState } from "./types";

export const defaultState = (): PayPlanChangeRequestState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    payPlanChangeRequests: [],
    links: {}
  };
};

export const state = defaultState();
